const productGallery = () => {
  const init = () => {
    gallery();
  };

  const gallery = () => {
    document.addEventListener("DOMContentLoaded", function () {
      const firstImage = document.querySelector(".js-atribute-gallery a");

      if (null !== firstImage)
        firstImage.setAttribute(
          "data-elementor-lightbox-slideshow",
          "my-lightbox"
        );

      // Get the second gallery container
      const galleryImages = document.querySelectorAll(
        ".js-atribute-gallery .e-gallery-item"
      );

      // Set the same data-elementor-lightbox-slideshow attribute value for all images
      if (null !== galleryImages)
        galleryImages.forEach(function (image) {
          image.setAttribute(
            "data-elementor-lightbox-slideshow",
            "my-lightbox"
          );
        });
    });
  };

  init();
};

try {
  productGallery();
} catch (error) {
  console.log(error);
}
